import React, { useContext } from 'react';
import classNames from 'classnames';
import Intl from '@fx-ui/intl';
import { Tooltip } from '@fx-ui/fine-design';
import {
    getFavoriteOptions,
    includes,
    indexOf,
    isEmpty,
    isPersonaFieldAvailable,
    map,
    size
} from '~/utils';
import PersonaContext from '../../context/persona';
import PersonaCollectItem from '../persona-collect-item';
import { EMPTY_ARRAY } from '@libs/shared';

// 管理需求最多选3个
const MAX_FAVORITES_COUNT = 3;

/**
 * 管理需求
 *
 * 选项有两种来源（由 personaLabel.favorites 是否有值决定）：
 * 1. 有值：单独配置，选项与所属行业无关
 * 2. 无值：与所属行业联动，选项取自 industries[industry]
 */
const Favorite = () => {
    const { personaInfo, setPersonaInfo, personaLabel } = useContext(PersonaContext);
    const { industry, favorites = EMPTY_ARRAY } = personaInfo || {};

    const isFavoritesCountOverLimit = size(favorites) >= MAX_FAVORITES_COUNT;

    if (!isPersonaFieldAvailable(personaLabel, 'favorites', { industry: industry?.value })) {
        return null;
    }

    const changeFavorite = (item: any) => {
        let hasChosenDemand = true;
        const idx = indexOf(favorites, item.value);
        const arr = favorites.slice();
        if (idx > -1) {
            arr.splice(idx, 1);
            if (isEmpty(arr)) {
                hasChosenDemand = false;
            }
        } else {
            arr.push(item.value);
        }
        setPersonaInfo({
            favorites: arr,
            hasChosenDemand
        });
    };

    return (
        <PersonaCollectItem
            className="fx-persona-favorite"
            title={Intl.get('persona.favorite.demand')}
        >
            {map(getFavoriteOptions(personaLabel, industry?.value || ''), (item) => {
                const isSelectedItem = includes(favorites, item.value);
                const isDisabledFavoriteItem = !isSelectedItem && isFavoritesCountOverLimit;
                const favoriteItem = (
                    <div
                        key={item.value}
                        className={classNames('select-item', {
                            disable: isDisabledFavoriteItem,
                            select: isSelectedItem
                        })}
                        onClick={() => {
                            if (isDisabledFavoriteItem) {
                                return;
                            }
                            changeFavorite(item);
                        }}
                    >
                        <div className="item-info">{item.text}</div>
                    </div>
                );
                if (isDisabledFavoriteItem) {
                    return (
                        <Tooltip
                            key={item.value}
                            content={Intl.get('persona.favorite.limit', {
                                count: MAX_FAVORITES_COUNT
                            })}
                            placement="top"
                        >
                            {favoriteItem}
                        </Tooltip>
                    );
                }
                return favoriteItem;
            })}
        </PersonaCollectItem>
    );
};

export default Favorite;
